



























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import NoteDto from '@/models/Notes/NoteDto';
import EntityType from '@/models/Shared/EntityType';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import NoteCreate from '@/components/Notes/NoteCreate.vue';
import NoteEdit from '@/components/Notes/NoteEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import NoteType from '@/models/Notes/NoteType';
import { AppModule } from '@/store/modules/app';
import UserDto from '@/models/Users/UserDto';


@Component({
  name: 'Notes',
  components: { NoteCreate, NoteEdit }
})
export default class extends GiganautVue {

    @Prop()
    entityType: EntityType;

    noteType = NoteType;

    async created() {
        switch (this.entityType){
            case EntityType.Booking:
                await BookingDetailsModule.getNotes();
                await BookingDetailsModule.getNoteCategories();
                break;
            case EntityType.Job:
                await JobDetailsModule.getNotes();
                await JobDetailsModule.getNoteCategories();
                break;
            case EntityType.Worker:
                await WorkerDetailsModule.getNotes();
                await WorkerDetailsModule.getNoteCategories();
                break;
            case EntityType.Company:
                await CompanyDetailsModule.getNotes();
                await CompanyDetailsModule.getNoteCategories();
                break;
            case EntityType.Contact:
                await ContactDetailsModule.getNotes();
                await ContactDetailsModule.getNoteCategories();
                break;
            case EntityType.Location:
                await LocationDetailsModule.getNotes();
                await LocationDetailsModule.getNoteCategories();
                break;
            case EntityType.Campaign:
                await CampaignDetailsModule.getNotes();
                await CampaignDetailsModule.getNoteCategories();
                break;
        }
    }

    get notes() {
        switch (this.entityType){
            case EntityType.Booking:
                return BookingDetailsModule.notes;
            case EntityType.Job:
                return JobDetailsModule.notes;
            case EntityType.Worker:
                return WorkerDetailsModule.notes;
            case EntityType.Company:
                return CompanyDetailsModule.notes;
            case EntityType.Contact:
                return ContactDetailsModule.notes;
            case EntityType.Location:
                return LocationDetailsModule.notes;
            case EntityType.Campaign:
                return CampaignDetailsModule.notes;
        }
    }

    getUserAvatarUrl(user: UserDto) {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + user.id + "/resized-100/" + user.avatar;
    }
}
